<template>
<nav class="navbar navbar-default">
  <div class="container-fluid">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <a class="navbar-brand" href="/agenda"> <img src="../../../assets/luandre.png" alt=""> <small style="font-size:11px"> FastRH | Módulo Administrativo</small> </a>
    </div>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
      <p class="navbar-text" style="margin-top:0;">Logado como: <span class="label label-default"> {{ nome }} </span> </p>
      <ul class="nav navbar-nav navbar-right">
        <li><a href="/agenda">Agenda</a></li>
        <li><a href="/recepcao">Recepção</a></li>
        <li><a href="/estoque">Estoque</a></li>
        <li><a href="/configuracoes">Configurações</a></li>
        <li><a href="/dashboard">Dashboard</a></li>
        <li><a href="http://fastrhluandre.com.br">FastRH</a></li>
        <li>
          <div class="form-group " style="margin: 8px 0;">
            <select name="UnidadeLuandre" id="UnidadeLuandre" class="form-control" @change="mudouLuandre" v-model="filialSel">
              <option disabled value="">Selecione...</option>
              <option value="0">Matriz</option>
              <option value="1">ABC</option>
              <option value="2">Alphaville</option>
              <option value="4">Campinas</option>
              <option value="5">Curitiba</option>
              <option value="6">Faria Lima</option>
              <option value="7">Guarulhos</option>
              <option value="8">Jundiaí</option>
              <option value="14">Recife</option>
              <option value="10">Rio de Janeiro</option>
              <option value="11">Santo Amaro</option>
            </select>
          </div>
        </li>
        <li>
          <button v-show="permissaoBotaoEspontaneo" style="margin: 0 0 0 12px;" type="button" class="btn btn-info" title="Espontâneo" @click="espontaneo" > <i class="fa fa-user-plus" aria-hidden="true"></i> </button>
          <button style="margin: 8px 8px 8px 3px;" type="button" class="btn btn-primary" title="Lista de Ramais da Intranet" @click="ramais" > <i class="fa fa-address-book" aria-hidden="true"></i> </button>
          <button style="margin: 8px 0px 8px -4px;" type="button" class="btn btn-warning" title="Logout" @click="logout" > <i class="fa fa-sign-out" aria-hidden="true"></i> </button>
        </li>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->


<div class="modal zoom " tabindex="-1" role="dialog" id="modalRamais">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content text-left">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title text-left">Ramais da Intranet </h4>
        </div>
        <div class="modal-body">
          <v-select v-model="colaborador" value="Chave" label="Valor" :options="listaColaboradores" @change="buscar()"></v-select>
          <!-- <div class="form-group">
            <label for="assessores">Nome ou E-mail do Colaborador</label>
            <input type="text" class="form-control" id="assessores" @keyup.enter="buscar" placeholder="" v-model="colaborador" >
          </div>  -->
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" >Fechar</button>
          <button type="button" class="btn btn-primary" @click="buscar()">Buscar</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->


  <Espontaneo />
</nav>
</template>

<script>
import vSelect from 'vue-select'
import Espontaneo from '../modal/Espontaneo.vue'
export default {
  name: 'navbar',
  components: {
    Espontaneo,
    vSelect
  },
  created () {
    this.filialSel = localStorage.getItem('Unidade') == null ? 0 : localStorage.getItem('Unidade')
    this.permissaoBotaoEspontaneo = JSON.parse(localStorage.getItem('Usuario')).BotaoEspontaneo === 'OK'
    this.listarColaboradores()
  },
  methods: {
    listarColaboradores () {
      this.$http.get('pesquisa/ramais')
      .then(function (res) {
        this.listaColaboradores = res.body
      })
    },
    logout () {
      localStorage.removeItem('Usuario')
      location.href = '/'
    },
    espontaneo () {
      $('#modalEspontaneo').modal('show')
    },
    mudouLuandre () {
      localStorage.setItem('Unidade', this.filialSel)
      this.atualizar()
    },
    atualizar () {
      location.reload()
    },
    ramais () {
      this.colaborador = ''
      $('#modalRamais').modal('show')
    },
    buscar () {
      window.open('http://intranet.luandre.com.br/?s=ramais+' + this.colaborador.Chave, '_blank')
    }
  },
  data () {
    return {
      filialSel: 0,
      nome: JSON.parse(localStorage.getItem('Usuario')).Usuario.Nome,
      permissaoBotaoEspontaneo: false,
      colaborador: '',
      listaColaboradores: []
    }
  }
}
</script>

<style scoped>
.navbar{
  padding: 5px 0 20px 0;
   background:#013c63;
   margin-bottom: 0;
}
 .navbar a,  .navbar p {
   color: #fff !important;
 }
 .navbar a:hover {
   color: #dcdcdc !important;
 }
.navbar-right{
  margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?117b701c